import { createClient } from '../clientConfiguration';

export const autom8tlyApiClient = createClient({
  baseURL: '/rest-api/sms/tendlc',
});

export interface GetAutom8tlyUrlResponse {
  autom8tlyBaseUrl: string;
  jwtToken: string;
  partnerId: string;
  tenantId: string;
  userUuid: string;
}

export const getAutom8tlyUrl = async (
  corpAcctNumber: number,
  ssoToken: string,
) => {
  const response = await autom8tlyApiClient.get<GetAutom8tlyUrlResponse>(
    `/corp-accounts/${corpAcctNumber}/v1/createJWTAuthMetadata`,
    {
      headers: {
        'nextiva-context-corpAcctNumber': corpAcctNumber,
        Authorization: `Bearer ${ssoToken}`,
      },
    },
  );
  return response.data;
};
